import { BadgeEntity } from "@modules/profile/publicProfile/entities/badgeEntity"
import { type UserBadgeDto } from "@modules/profile/publicProfile/gateway/publicProfileDto"

export class UserBadgeEntity {
  userBadgeId: string
  badge: BadgeEntity
  additionalInformation: string | null
  date: Date

  private constructor(entity: UserBadgeEntity) {
    this.userBadgeId = entity.userBadgeId
    this.badge = entity.badge
    this.additionalInformation = entity.additionalInformation
    this.date = entity.date
  }

  static fromDto(dto: UserBadgeDto): UserBadgeEntity {
    return new UserBadgeEntity({
      userBadgeId: dto.userBadgeId,
      badge: BadgeEntity.fromDto(dto.badge),
      additionalInformation: dto.additionalInformation ?? null,
      date: new Date(dto.date),
    })
  }
}
